/* eslint-disable import/no-default-export */
import Cookies from 'js-cookie';

class Token {
  private readonly name = `token${window.location.port}`;
  token: string | null;
  myId: string | null;

  constructor() {
    this.update();
  }

  update() {
    this.token = Cookies.get(this.name) || null;
    if (this.token) {
      this.myId = this.token.split('/')[0];
    }
  }

  getMyId() {
    return this.myId;
  }

  remove() {
    Cookies.remove(this.name, { path: '/' });
    window.location.reload();
  }
}

export default new Token();



// WEBPACK FOOTER //
// ./app/common/lib/util/token.ts